'use client';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import clsx from 'clsx';
import { AnimatePresence, domMax, LazyMotion, m, } from 'motion/react';
import { Children, isValidElement, useCallback, useEffect, useId, useMemo, useState, } from 'react';
import { Button, Panel, Stack, } from '../../index.js';
import styles from './tabs.module.css';
import { TabPanel } from './tabs-panel.js';
const radius = {
    small: 12,
    regular: 16,
    big: 24,
};
export const Tabs = ({ className, children, onValueChange, listGap, dimension = 'regular', inline, style, ...otherProps }) => {
    const [activeItem, setActiveItem] = useState(otherProps.defaultValue);
    const uid = useId();
    const dynamicStyle = useMemo(() => ({
        '--tabs-list-gap': listGap && tkns.space[listGap],
    }), [listGap]);
    const handleOnVlaueChange = useCallback((value) => {
        setActiveItem(value);
        onValueChange?.(value);
    }, [onValueChange]);
    useEffect(() => {
        if (otherProps.value) {
            setActiveItem(otherProps.value);
        }
    }, [handleOnVlaueChange, otherProps.value]);
    return (_jsxs(TabsPrimitive.Root, { ...otherProps, "data-tabs-dimension": dimension, className: clsx(styles.Tabs, className), style: { ...style, ...dynamicStyle }, onValueChange: handleOnVlaueChange, defaultValue: activeItem, value: activeItem, children: [_jsx(LazyMotion, { features: domMax, strict: true, children: _jsx(Panel, { bordered: true, radius: radius[dimension], vPadding: 4, hPadding: 4, vibrant: true, vibrancyColor: "soft", className: styles.List, "data-tabs-inline": inline, children: _jsx(Stack, { as: TabsPrimitive.List, direction: "row", fill: false, hAlign: "start", children: Children.map(children, child => isValidElement(child) && (_jsx(TabsPrimitive.Trigger, { value: child.props.value, disabled: child.props.disabled, className: styles.Trigger, asChild: true, children: _jsxs(Button, { kind: "flat", dimension: dimension, icon: child.props.icon, children: [_jsxs(Stack, { as: "span", className: styles.Label, direction: "row", vAlign: "center", hAlign: "center", columnGap: 8, inline: true, children: [child.props.label, child.props.decorator] }), _jsx(AnimatePresence, { children: (child.props.value === activeItem) && (_jsx(m.span, { className: styles.Highlight, layoutId: `${uid}-tab-highlight-lazy` })) }, activeItem)] }) }))) }) }) }), children] }));
};
Tabs.Panel = TabPanel;
